const invalidFonObj = {
    style: '',
    variant: '',
    weight: '',
    size: -1,
    lineHeight: '',
    family: [],
    bold: false,
    italic: false,
};
const fontRegEx = /(?<style>.*?)\s(?<variant>.*?)\s(?<weight>.*?)\s(?<size>.*?)\s(?<fullFontFamily>.*)/;
const extractFromQuotes = (str) => {
    const match = str.match(/'(?<strInQuotes>.*?)'/);
    return match ? match.groups.strInQuotes : str;
};
export const parseFontStr = (font) => {
    const match = font.match(fontRegEx);
    if (!match) {
        return invalidFonObj;
    }
    const { style, variant, weight, size, fullFontFamily } = match.groups;
    const sizeSplit = size ? size.split('/') : [];
    const fullFontFamilyArr = fullFontFamily
        .split(',')
        .map(currFamily => extractFromQuotes(currFamily));
    return {
        style,
        variant,
        weight,
        size: parseInt(sizeSplit[0].replace('px', ''), 10),
        lineHeight: sizeSplit[1],
        family: fullFontFamilyArr,
        bold: weight === 'bold' || parseInt(weight, 10) >= 700,
        italic: style === 'italic',
    };
};
const fixFontWithSpaceOrNotLatinChars = (font) => font.replace(/[^,]*[^\w,\d-][^,]*/g, fontFamilyStr => `'${fontFamilyStr.replace(/\+/g, ' ')}'`);
export const fontObjectToString = ({ style, variant, weight, size, lineHeight, family, }) => {
    const fullFontFamily = fixFontWithSpaceOrNotLatinChars(family.join(','));
    return `${style} ${variant} ${weight} ${size}px/${lineHeight} ${fullFontFamily}`;
};
//# sourceMappingURL=fontParser.js.map